import { useEffect, useState } from "react";
import { useGetArtifactDetailsByIdQuery } from "../../../endpoints/getArtifactDetailsById";
import { Notice } from "./types";

export const useNoticeSelection = (valueNotices: Notice[]) => {
    const [selected, setSelected] = useState<{ [key: string]: boolean }>({});

    useEffect(() => {
        const initialSelected = valueNotices.reduce(
            (acc, notice) => {
                acc[notice.artifactId] = notice.enable || false;

                return acc;
            },
            {} as { [key: string]: boolean }
        );
        setSelected(initialSelected);
    }, [valueNotices]);

    const onChangeRow = (id: string) => (value: boolean) => {
        setSelected(prev => ({ ...prev, [id]: value }));
    };

    return { selected, onChangeRow };
};

export const useNoticeQueries = (valueNotices: Notice[]) => {
    const queries = valueNotices.map(notice =>
        useGetArtifactDetailsByIdQuery({
            artifactId: notice.artifactId,
            artifactType: "DOCUMENT",
            businessUseCase: "SMART",
        })
    );

    const isLoading = queries.some(query => query.isLoading);
    const isError = queries.some(query => query.isError);

    return { queries, isLoading, isError };
};

export const useUpdateAppealHandler = (
    updateAppeal: any,
    data: any,
    alias: string,
    onSuccess: () => void
) => {
    return async (updatedNotices: Notice[]) => {
        try {
            const updatedData = JSON.parse(JSON.stringify(data));

            if (
                updatedData.appealDetails?.appealApproachCalculationData.exportAppealsPackage
                    .valueNotices
            ) {
                updatedData.appealDetails.appealApproachCalculationData.exportAppealsPackage.valueNotices =
                    updatedNotices;
            }

            await updateAppeal({
                businessUseCase: "SMART",
                appealArtifactId: data.appealArtifactId,
                appealDetails: updatedData.appealDetails,
                appealStatus: data.appealDetails.status,
                clientName: alias,
            });

            onSuccess();
        } catch (error) {
            console.error("Error updating appeal:", error);
        }
    };
};

export const handleViewPdf = (url: string) => {
    if (url) {
        window.open(url, "_blank");
    }
};
